(function () {
  window.dataLayer = window.dataLayer || [];
  window.gg = window.gg || {};

  gg.eventTypes = {
    CART_ADD: "dl_add_to_cart",
    // CART_CLEAR: "dl_clear_cart",
    CART_REMOVE: "dl_remove_from_cart",
    CART_VIEW: "dl_view_cart",
    CLICK: "Click",
    // COLLECTION_VIEW: "dl_view_item_list",
    NAVIGATE_TO_CHECKOUT: "ee_checkout",
    PAGE_VIEW: "pageview",
    PRODUCT_VIEW: "dl_view_item",
    PRODUCT_CLICK: "dl_select_item",
    PROMO_CLICK: "collection_promo_click",
    SEARCH_QUERY: "dl_search_query",
    // SUBSCRIBE: "dl_subscribe",
    USER_DATA: "dl_user_data",
    VIEW_ITEM_LIST: "dl_view_item_list",
    VIEW_SEARCH_RESULTS: "dl_view_search_results",
  };

  gg.toMoney = toMoney;
  gg.sendEvent = function (props) {
    switch (props.type) {
      case gg.eventTypes.CART_ADD:
        handleCartAdd(props);
        break;
      // case gg.eventTypes.CART_CLEAR:
      //   handleCartClear(props);
      //   break;
      case gg.eventTypes.CART_REMOVE:
        handleCartRemove(props);
        break;
      case gg.eventTypes.CART_VIEW:
        handleCartView(props);
        break;
      case gg.eventTypes.CLICK:
        handleClick(props);
        break;
      case gg.eventTypes.VIEW_ITEM_LIST:
        handleResultsView(props);
        break;
      case gg.eventTypes.PAGE_VIEW:
        handlePageView();
        break;
      case gg.eventTypes.PRODUCT_VIEW:
        onProductView(props);
        break;
      case gg.eventTypes.PROMO_CLICK:
        handlePromoClick(props);
        break;
      case gg.eventTypes.SEARCH_QUERY:
        handleSearchQuery(props);
        break;
      case gg.eventTypes.VIEW_SEARCH_RESULTS:
        handleResultsView(props);
        break;
      // case gg.eventTypes.SUBSCRIBE:
      //   sendGTMEvent(props);
      //   break;
    }
  };

  function handleSearchQuery(props) {
    window.dataLayer.push({
      event: gg.eventTypes.SEARCH_QUERY,
      query: props.query || '',
      no_hits: props.noHits || false
    });
  }

  function handleCartAdd({ data }) {
    const { variants } = data;
    const list = getListProp(location.href);

    sendBaseEvent(list);

    window.dataLayer.push({
      event: gg.eventTypes.CART_ADD,
      user_properties: formatUserProperties(gg.eventData.customer),
      ecommerce: {
        currencyCode: "NZD",
        add: {
          actionField: {
            list,
          },
          products: formatLines(variants, list),
        },
      },
    });
  }

  // function handleCartClear(props) {
  //   handleCartRemove(props);
  // }

  function handleCartRemove({ data }) {
    const { customer } = gg.eventData;
    const list = getListProp(location.href);

    sendBaseEvent(list);

    window.dataLayer.push({
      event: gg.eventTypes.CART_REMOVE,
      user_properties: formatUserProperties(customer),
      ecommerce: {
        currencyCode: "NZD",
        remove: {
          actionField: {
            list,
          },
          products: formatLines(data.items, list),
        },
      },
    });
  }

  function handleCartView() {
    const { cart, customer } = gg.eventData;
    const list = getListProp(location.href);

    window.dataLayer.push({
      event: gg.eventTypes.CART_VIEW,
      user_properties: formatUserProperties(customer),
      cart_total: toMoney(cart?.cartTotal),
      ecommerce: {
        currencyCode: "NZD",
        actionField: {
          list: "Shopping Cart",
        },
        impressions: formatLines(cart?.items, list),
      },
    });
  }

  function handleClick({ data }) {
    const { customer } = gg.eventData;
    const { hit, index = "", position = null } = data;
    const list = getListProp(location.href);

    const isProductResult = index?.includes("products");

    if (isProductResult) {
      sendBaseEvent(list);

      window.dataLayer.push({
        event: gg.eventTypes.PRODUCT_CLICK,
        user_properties: formatUserProperties(customer),
        ecommerce: {
          currencyCode: "NZD",
          click: {
            actionField: {
              list,
              action: "click",
            },
            products: formatImpressions([{ ...hit, position }], list),
          },
        },
      });
    }
  }

  function handlePageView() {
    window.dataLayer.push({
      event: gg.eventTypes.PAGE_VIEW,
      page_location: location.href,
    });

    sendBaseEvent(getListProp(location.href));
  }

  function onProductView({ product, variants }) {
    const { customer } = gg.eventData;
    const list = getListProp(location.href);

    window.dataLayer.push({
      event: gg.eventTypes.PRODUCT_VIEW,
      user_properties: formatUserProperties(customer),
      ecommerce: {
        currencyCode: 'NZD',
        detail: {
          actionField: {
            list,
            action: 'detail',
          },
          products: variants.map(variant => {
            const p = variant.is_child && variant.product || product;

            return ({
              id: variant.sku || '',
              name: p.title?.replace(`'`, '') || '',
              brand: getBrandFromVendor(p.vendor),
              category: p.type || '',
              variant: variant.title?.replace(`'`, '') || '',
              price: String(toMoney(variant.price / 100)),
              list,
              product_id: formatItemId(p.id),
              variant_id: formatItemId(variant.id),
              compare_at_price: variant.compare_at_price ? String(toMoney(variant.compare_at_price / 100)) : "",
              image: p.featured_image || ''
            })
          }),
        },
      },
    })
  }

  function handleResultsView({ hits, type }) {
    const { customer } = gg.eventData;
    const isSearch = type === gg.eventTypes.VIEW_SEARCH_RESULTS;

    window.dataLayer.push({
      event: type,
      user_properties: formatUserProperties(customer),
      ecommerce: {
        currencyCode: "NZD",
        impressions: formatImpressions(hits, getListProp(location.href)),
        ...(isSearch
          ? {
              actionField: {
                list: "search results",
              },
            }
          : {}),
      },
    });
  }

  function handlePromoClick({ data, type }) {
    window.dataLayer.push({
      event: type,
      collection_handle: data.collectionHandle,
      title: data.title
    });
  }

  function sendBaseEvent(list) {
    const { cart, customer } = gg.eventData;

    window.dataLayer.push({
      event: gg.eventTypes.USER_DATA,
      cart_total: toMoney(cart?.subtotal || 0),
      user_properties: formatUserProperties(customer),
      ecommerce: {
        currencyCode: "NZD",
        cart_contents: {
          products: formatLines(cart?.items, list),
        },
      },
    });
  }

  // HELPERS

  function formatLines(lines, list) {
    return [].concat(lines).map((line, i) => ({
      id: String(line.id) || "",
      name: formatProductTitle(line.name),
      brand: line.brand,
      category: line.category || "",
      variant: formatProductTitle(line.variant),
      price: toMoney(line.price / 100),
      position: i + 1,
      quantity: String(line.quantity),
      list,
      product_id: String(line.productId),
      variant_id: String(line.variantId),
      compare_at_price: toMoney(line.compareAtPrice / 100) || "",
      image: line.image || "",
    }));
  }

  function formatImpressions(products, list) {
    return products.map((product, i) => ({
      id: "", // Sku goes here - not available for impressions
      name: formatProductTitle(product.title),
      brand: getBrandFromVendor(product.vendor),
      category: product.productType || "",
      variant: "", // None available for impressions
      price: toMoney(product.minPrice),
      position: i + 1,
      list,
      product_id: formatItemId(product.id),
      variant_id: "", // None available for impressions
      compare_at_price: String(product.compareAt || ""),
      image: product.image?.src || "",
    }));
  }

  function formatItemId(x) {
    const id = x.toString();

    if (id.slice(-1) === "=") return getIdFromGid(decodeURIComponent(id));

    return `${id}`;
  }

  function formatProductTitle(title) {
    return title?.replace("'", "") || "";
  }

  function formatUserProperties(customer) {
    return {
      user_consent: "",
      visitor_type: customer ? "logged_in" : "guest",
      ...(customer?.id ? { customer_id: String(customer.id) } : {}),
      ...(customer?.email ? { customer_email: customer.email } : {}),
      customer_tags: customer?.tags || "",
    };
  }

  function getBrandFromVendor(vendor) {
    return vendor ? vendor.replace(`'`, "").replace("ö", "o") : "";
  }

  function getListProp(from) {
    return from[0] === "/" ? `${getDomain()}${from}` : from;
  }

  function getDomain(withProtocol = true) {
    if (typeof window === "undefined") return "";

    return location[withProtocol ? "origin" : "host"];
  }

  function toMoney(money, decimal = 2) {
    return roundTo(money, decimal).toFixed(decimal);
  }

  function roundTo(val = 0, digits = 2) {
    const multiple = Math.pow(10, digits);
    return Math.round(val * multiple) / multiple;
  }
})();
